<template>
    <div class="air-container  " :class="dolyamiAir ? 'air-container_active':''" id="split">
        <div class="popup-air  " :class="dolyamiAir ? 'popup-air_active':''">
            <div class="air-close" @click="dolyamiAir = !dolyamiAir"></div>
            <div class="credit-popup">
                <div class="credit-popup__wrapper">
                    <div class="credit-popup__img-mob">
                        <picture>
                            <source srcset="https://batnorton.com/img/mob-credit.webp" type="image/webp">
                            <img src="https://batnorton.com/img/mob-credit.jpg" class="img-element" alt="">
                        </picture>
                    </div>
                    <div class="credit-popup__logo">
                        <img class="img-element" src="https://batnorton.com/img/svg/credit2.svg" alt="">
                    </div>
                    <p class="credit-popup__percent">25% Минимальная стоимость заказа для оплаты долями —
                        1000 руб. Максимальная — 40000 руб, остальное - потом</p>
                    <div class="credit-popup__percent-mobile">
                        <div class="credit-popup__redactor">
                            <p class="text-element">Долями – оплатите 25% от суммы покупки сейчас, остальное
                                - потом. Разделите стоимость покупки на 4 равные части и оплачивайте с
                                особым комфортом.</p>
                            <p class="text-element">Первый платёж сейчас, остальные 3 платежа спишутся
                                автоматически с периодичностью в 2 недели. </p></div>
                        <p class="min-price">The minimum order cost for payment in installments is 1000
                            rubles. The maximum is 30,000 rubles.</p></div>
                    <div class="credit-popup__progress-bar">
                        <div class="credit-popup__progress-element credit-popup__progress-element_active">
                            <div class="credit-popup__progress-line"></div>
                            <p class="credit-popup__progress-price">{{ $parent.splitPayment(card) }} ₽</p>
                            <p class="credit-popup__progress-subtitle">Сегодня</p>
                        </div>
                        <div class="credit-popup__progress-element">
                            <div class="credit-popup__progress-line"></div>
                            <p class="credit-popup__progress-price">{{ $parent.splitPayment(card) }} ₽</p>
                            <p class="credit-popup__progress-subtitle">Через 2 недели</p></div>
                        <div class="credit-popup__progress-element">
                            <div class="credit-popup__progress-line"></div>
                            <p class="credit-popup__progress-price">{{ $parent.splitPayment(card) }} ₽</p>
                            <p class="credit-popup__progress-subtitle">Через 4 недели</p></div>
                        <div class="credit-popup__progress-element">
                            <div class="credit-popup__progress-line"></div>
                            <p class="credit-popup__progress-price">{{ $parent.splitPayment(card) }} ₽</p>
                            <p class="credit-popup__progress-subtitle">Через 6 недели</p></div>
                    </div>
                    <div class="credit-popup__text">
                        <div class="credit-popup__redactor">
                            <h2 class="title-element">Плюсы сервиса: </h2>
                            <p class="text-element">Оплачивайте покупки частями – каждые 2 недели по 25%,
                                никаких дополнительных платежей, процентов или наценок; </p>
                            <p class="text-element">Не требует документов и никак не влияет на кредитную
                                историю, так как не является кредитным продуктом; </p>
                            <p class="text-element">Платить долями проще простого – это как обычная покупка,
                                только намного практичнее и удобнее</p></div>
                        <div class="credit-popup__redactor"><h2 class="title-element">Как оформить
                            заказ: </h2>
                            <ol class="number-list">
                                <li class="list__element number-list__element">Соберите корзину на общую
                                    сумму до 30 000 ₽
                                </li>
                                <li class="list__element number-list__element">При оформлении заказа
                                    выберите способ оплаты «Долями»
                                </li>
                                <li class="list__element number-list__element">Спишем 25% от общей суммы
                                    заказа сразу
                                </li>
                                <li class="list__element number-list__element">Оставшиеся 3 части
                                    автоматически будут списываться каждые 2 недели
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div class="credit-popup__info">
                        <div class="credit-popup__email">Оформленный и оплаченный заказ можно вернуть в
                            течение предусмотренного публичной оффертой времени, написав об этом комьюнити –
                            <a class="link-element" href="mailto:info@batnorton.com">info@batnorton.com</a>
                        </div>
                        <div class="credit-popup__phone">Наша служба поддержки работает ежедневно с 9 до 21
                            (Мск) по телефону
                            <a class="link-element" href="tel:+7 (499) 703-40-20">+7 (499)703-40-20</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        card:{
            type:Object,

        }
    },
name: "dolyami",
    data(){
    return{
        dolyamiAir:false,
    }
    },
    
}
</script>

<style scoped>

</style>
